import React, { memo } from "react";

type Props = {
    text: string;
    style?: React.CSSProperties; // Optional style prop
};

const ItemNotAvailable = ({ text, style }: Props) => {
    return (
        <div className="table_disable_row" style={style}>
            <div className="table_disable_row__chip">{text}</div>
        </div>

    )
}

export default memo(ItemNotAvailable)
